import { Dropdown, Select, Space } from 'antd';
import $ from 'jquery';
import 'jquery-ui/ui/widgets/sortable';
import React, { useContext, useEffect, useRef, useState } from 'react';
import ReactGA from 'react-ga4';
import Toastr from 'toastr';
import SiteWeather from "./../../components/dashboard/SiteWeather";
import ZoneCard from './../../components/dashboard/ZoneCard';
import Loading from "./../../components/Loading";
import SessionManager from './../../routes/SessionManager';
import DateUtil from './../../util/DateUtil';
import moment from 'moment';
import TalkDownModal from '../modals/TalkDownModal';
import Modal from '../bootstrap4/Modal';
import CommonUtils from '../../util/CommonUtils';
import { Context } from '../../views/app';
import CountdownTimer from '../../util/CountdownTimer';
import StrobeModal from '../modals/StrobeModal';

let zone_order = null;
const DashboardSites = () => {
    let context = useContext(Context);
    let sessionMgr = new SessionManager();
    let user = sessionMgr.readCookie('user');
    let isMount = useRef(true);
    user.default_dashboard = 'Dashboard';

    if (!user["zone_prefs_for_sites"]) {
        for (var index = 0; index < user.user_sites.length; index++) {
            var user_site = user.user_sites[index];
            user["zone_prefs_for_sites"] = { ...user["zone_prefs_for_sites"], [user_site]: user.zone_prefs }
        }
    }

    const [site_locations, setSiteLocations] = useState([]);
    const [zones, setZones] = useState(null);
    const [site_selected, setSiteSelected] = useState(null);
    const [loading, setLoading] = useState(true);
    const [zone_events, setZoneEvents] = useState({});
    const [last_refresh, setLastRefresh] = useState(new Date().getTime());
    const [zonesOrder, setZonesOrder] = useState(null);
    const [save_prefs, setSavePrefs] = useState(false);
    const [customer, setCustomer] = useState(null);
    const [commboxDevices, setCommboxDevices] = useState([]);

    var custID = user.customer_id;
    ReactGA.set({ userId: custID });

    useEffect(() => {
        fetchProcoreConfig();
        if (user.site_locations) {
            let siteDefault = user.site_selected;
            if (!siteDefault)
                siteDefault = getDefaultSite(user.site_locations);
            setSiteLocations(user.site_locations);
            setSiteSelected(siteDefault);
        } else {
            fetchSiteLocations();
        }
        return () => isMount.current = false;
    }, []);

    useEffect(() => {
        if (site_selected !== null) {
            fetchCustomer();
            fetchSiteLocationZones();
            resetReloadInterval();
        }
    }, [site_selected]);

    useEffect(() => {
        if (zones !== null) {
            var user1 = sessionMgr.readCookie('user');
            user1.zones = [...zones];
            user1.site_locations = site_locations;
            sessionMgr.storeCookie('user', user1);
            let location_ids = [];
            for (var i = 0; i < user1.zones.length; i++) {
                location_ids.push(user1.zones[i].location_id);
            }

            fetchCommBoxDevicesInfo(location_ids);

            $.event.trigger("refresh_notifications");
            let sortableContainer = $('.sortable');
            sortableContainer.sortable({
                placeholder: ".sortable-placeholder",
                forcePlaceholderSize: true,
                stop: (event, ui) => {
                    const sortables = sortableContainer.sortable('toArray', { attribute: 'zone' })
                    sortableContainer.sortable('cancel');
                    var zones1 = [...zones];
                    var zonesSorted = [];
                    for (var i = 0; i < zones1.length; i++) {
                        zonesSorted[sortables.indexOf(zones[i].location_id)] = zones[i];
                    }
                    setLastRefresh(new Date().getTime());
                    setZones(zonesSorted);
                    setZonesOrder([...sortables]);
                    zone_order = [...sortables];
                    if (!zoneOrderChanged()) {
                        resetReloadInterval();
                    }
                }
            });
        }
    }, [zones]);

    let resetReloadInterval = () => {
        var interval = setInterval(() => {
            if (isZonesOrderChanged()) {
                clearInterval(interval)
                return;
            }
            fetchSiteLocationZones();
        }, 125000);//Refresh every 125 sec
    }

    let isZonesOrderChanged = () => {
        var zonesOrder1 = zone_order;
        return zonesOrder1 ? JSON.stringify(user.zone_prefs_for_sites[site_selected.site_id]) !== JSON.stringify(zonesOrder1) : false;
    }

    let fetchProcoreConfig = () => {
        var data = {
            customer_id: user.customer_id,
            site_id: user.user_sites,
            user_login: user.user_login,
            user_token: user.user_token,
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/sitesupt-config/procore',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    if (res.data && res.data.length > 0) {
                        sessionMgr.storeCookie('procore', res.data[0]);
                        if (window.location.search.indexOf('code') !== -1) {
                            retrieveRefreshToken();
                        }
                    }
                }
            },
            (res) => {

            });
    }

    let retrieveRefreshToken = (token) => {
        var dataP = sessionMgr.readCookie('procore');
        var data = {
            "grant_type": "authorization_code",
            "refresh_token": "sitesupt"
        }

        data.client_id = dataP.client_id;
        data.client_secret = dataP.client_secret;
        data.redirect_uri = dataP.redirect_uri;
        data.code = new URL(window.location).searchParams.get('code');
        //console.log(JSON.stringify(data));

        $.ajax(
            {
                url: 'https://app.procore.com/oauth/token',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    console.log('Procore Response ' + res);
                }
            },
            (res) => {

            });
    }

    let fetchSiteLocations = () => {
        var data = {
            customer_id: user.customer_id,
            site_id: user.user_sites,
            user_login: user.user_login,
            user_token: user.user_token
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/site',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    let site_locations = res.data ? res.data.filter(x => x.site_state !== 'Inactive') : [];
                    let loc = 'site_name';
                    site_locations = site_locations.sort((a, b) => a[loc] > b[loc] ? 1 : a[loc] < b[loc] ? -1 : 0);
                    setSiteLocations(site_locations);
                    let siteDefault = getDefaultSite(site_locations);
                    if (siteDefault) {
                        let user1 = JSON.parse(JSON.stringify(user));
                        user1.site_selected = siteDefault;
                        user1.site_locations = site_locations;
                        sessionMgr.storeCookie('user', user1);
                        onSiteLocationChange(siteDefault);
                    }
                }
            },
            (res) => {

            });
    }

    let getDefaultSite = (site_locations) => {
        var siteDefault = null;
        let defaultSiteId = user.site_id; //Default Site;

        if (!defaultSiteId)
            defaultSiteId = user.site_selected.site_id;

        if (defaultSiteId) {
            for (let s of site_locations)
                if (s.site_id + '' === defaultSiteId + '') {
                    siteDefault = s;
                    break;
                }
        }

        if (!siteDefault)
            siteDefault = site_locations[0];

        return siteDefault;
    }

    let fetchZonesEvents = (location_ids) => {

        return new Promise((resolve, reject) => {
            var data = {
                customer_id: user.customer_id,
                site_id: site_selected.site_id,
                user_login: user.user_login,
                user_token: user.user_token,
                location_ids: location_ids
            }
            let siteSelected = { ...user.site_selected };
            $.ajax(
                {
                    url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/event/fetch',
                    type: 'POST',
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    data: JSON.stringify(data)
                }
            ).then(
                (res) => {
                    if (res.status && res.status.code === 200) {
                        var timezone = site_selected.site_iana_timezone;
                        if (!timezone)
                            timezone = moment.tz.guess(); // User's timezone if not found

                        // Filtering events which are 1 day older or less.
                        var m1 = moment.tz(new Date().getTime(), timezone);
                        let workHours = { work_hours_start: '07:00', work_hours_end: '17:00' };
                        if (siteSelected.site_config && siteSelected.site_config.work_hours) {
                            workHours = siteSelected.site_config.work_hours;
                        }
                        //console.log('workHours', workHours);
                        function getEventStats(data) {
                            var counts = { alert: 0, warning: 0 };
                            var filteredEvents = (data).filter(evt => {
                                var m2 = moment.tz(evt.timestamp, timezone);
                                var diff = m1.diff(m2, 'days');

                                var allowEvent = false;
                                if (diff <= 1) {
                                    let HHmm = moment.tz(evt.timestamp, timezone).format('HH:mm');
                                    let day = moment.tz(evt.timestamp, timezone).format('dddd');
                                    if (workHours.extended_enabled) {
                                        for (const weekdays in workHours.work_schedule) {
                                            let event_day = day.toLowerCase();
                                            if (weekdays === event_day) {
                                                let work_hours = workHours.work_schedule[event_day];

                                                let HH = moment.tz(evt.timestamp, timezone).format('HH');
                                                let mm = moment.tz(evt.timestamp, timezone).format('mm');

                                                let wh_pos = parseInt(HH);
                                                if (work_hours.length > 24) {
                                                    wh_pos = 2 * wh_pos;
                                                    if (mm > 30)
                                                        wh_pos = wh_pos + 1;
                                                }

                                                if (work_hours[wh_pos] === 1) {
                                                    counts[evt.event_level.toLowerCase()] += 1;
                                                    allowEvent = true;
                                                }
                                            }
                                        }
                                    } else {
                                        if (HHmm >= workHours.work_hours_start && HHmm <= (workHours.work_hours_end === "00:00" ? "23:59" : workHours.work_hours_end)) {
                                            counts[evt.event_level.toLowerCase()] += 1;
                                            allowEvent = true;
                                        }
                                    }

                                    evt.event_level = evt.event_level.toLowerCase();
                                }
                                return allowEvent;
                            });
                            return { events: filteredEvents, counts: counts };
                        }

                        let zone_events = {};
                        for (let x in res.data)
                            zone_events[x] = getEventStats(res.data[x]);

                        //console.log('zone_events', zone_events)
                        resolve(zone_events);
                    } else {
                        resolve({});
                    }
                },
                (res) => {
                    resolve({});
                });
        });
    }

    let fetchSiteLocationZones = () => {

        var data = {
            customer_id: site_selected.customer_id,
            site_id: site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token
        }
        if (isMount.current) {
            setLoading(true);
        }
        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/location',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            async (res) => {
                if (res && res.status && res.status.code === 200) {
                    let zone_prefs = user.zone_prefs_for_sites[site_selected.site_id];
                    var filteredZones = site_selected.site_state === 'Inactive' ? res.data : (res.data).filter(zone => zone.location_adminstatus === "Up");
                    if (zone_prefs && zone_prefs.length > 0) {
                        var sortedZones = filteredZones.sort((a, b) => {
                            return zone_prefs.indexOf(a.location_id) - zone_prefs.indexOf(b.location_id);
                        });
                    } else {
                        sortedZones = filteredZones;
                    }

                    //User accessible zones only.
                    let user_zones = user.user_zones;
                    if (user_zones && user_zones[site_selected.site_id]) {
                        let zonesAllowed = user_zones[site_selected.site_id];
                        if (zonesAllowed.length > 0) {
                            let sortedZonesFinal = [];
                            for (let s of sortedZones) {
                                if (zonesAllowed.includes(s.location_id)) {
                                    sortedZonesFinal.push(s);
                                }
                            }
                            sortedZones = sortedZonesFinal;
                        }
                    }

                    let location_ids = [];
                    for (var i = 0; i < sortedZones.length; i++) {
                        location_ids.push(sortedZones[i].location_id);
                    }
                    let zone_events = await fetchZonesEvents(location_ids);
                    let zones1 = [...sortedZones];
                    for (const zone of sortedZones) {
                        if (zone.location_device_type === 'axis') {
                            let selected_zone = zones1.findIndex((z) => z.location_id === zone.location_id);
                            let Zone_preset = await getPTZPresets(zone);
                            zones1[selected_zone].preset = Zone_preset
                        }
                    }
                    if (isMount.current) {
                        setZones(zones1);
                        setZoneEvents(zone_events);
                        setLastRefresh(new Date().getTime());
                        setLoading(false);
                    }
                } else {
                    var user1 = sessionMgr.readCookie('user');
                    user1.zones = [];
                    sessionMgr.storeCookie('user', user1);
                    setZones(user1.zones);
                    setLoading(false);
                }
            },
            (res) => {

            });
    }

    let getPTZPresets = async (zone) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: "https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/axis-camera/ptz-presets",
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                headers: {
                    user_login: user.user_login,
                    user_token: user.user_token
                },
                data: JSON.stringify({
                    location_id: zone.location_id,
                    device_id: zone.device_id,
                    user_login: user.user_login,
                    user_token: user.user_token
                }),
                success: function (response) {
                    if (response.status && response.status.code === 200)
                        resolve(response.data)
                    else
                        resolve([])
                },
                error: function (xhr, status) {
                    resolve([])
                }
            });
        });
    }

    let saveZoneOrderPreferences = () => {
        setSavePrefs(true)
        var zone_prefs_for_sites = {
            ...user.zone_prefs_for_sites,
            [site_selected.site_id]: zonesOrder
        }
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            form_input: {
                zone_prefs: zonesOrder,
                zone_prefs_for_sites: zone_prefs_for_sites
            }
        };

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/user/modify',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res && res.status && res.status.code === 200) {
                    var user1 = { ...user };
                    user1.zone_prefs_for_sites[site_selected.site_id] = zonesOrder;
                    sessionMgr.storeCookie('user', user);
                    setSavePrefs(false);
                    Toastr.success('Preferences saved !');
                    resetReloadInterval()
                }
            },
            (res) => {
            });
        ReactGA.event({
            category: 'Action',
            action: 'Change Zone Order Preferences',
            label: 'Changed Preferences to ' + JSON.stringify(zonesOrder)
        });
    }

    let onSiteLocationChange = (site_selected) => {
        if (!site_selected) {
            for (var siteLocation of site_locations)
                if (siteLocation.site_id === user.site_id)
                    site_selected = { ...siteLocation };
            //console.log('Applying default :: ' + JSON.stringify(site_selected));
        }
        setSiteSelected(site_selected);
        setZones([]);
        setZonesOrder(user.zone_prefs_for_sites[site_selected.site_id]);
        zone_order = user.zone_prefs_for_sites[site_selected.site_id]
        var user1 = { ...user };
        user1.site_selected = site_selected;
        let site_config = {};
        if (user1.site_selected.site_config) {
            site_config = { ...user1.site_selected.site_config }
        }
        site_selected.site_config = { ...site_config, ...DateUtil.getConfiguredWorkHours(user1.site_selected) }
        ReactGA.event({
            category: 'Action',
            action: 'Change SiteLocation',
            label: 'Changed Site Location to ' + site_selected.site_id
        });
        context.updateUser(user1);
    }

    let zoneOrderChanged = () => {
        var zonesOrder1 = zonesOrder;
        return zonesOrder1 ? JSON.stringify(user.zone_prefs_for_sites[site_selected.site_id]) !== JSON.stringify(zonesOrder1) : false;
    }

    let fetchCommBoxDevicesInfo = (location_ids) => {
        var data = {
            customer_id: user.customer_id,
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: site_selected.site_id
        }

        $.ajax(
            {
                url: "https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/axis-camera/horn-devices",
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    let cDevices = [];
                    for (let d of res.data) {
                        let zone = zones.find(z => z.location_id === d.location_id);
                        if (zone) {
                            cDevices.push({
                                location_id: zone.location_id,
                                device_id: zone.device_id,
                                commbox_id: d.comm_box_id,
                                commbox_device_id: d.device_id,
                                talkDownEnabled: d.feat_talkdown === "true" || d.loc_cfg_talkdown === "true",
                                strobeEnabled: d.feat_strobe === "true" || d.loc_cfg_strobe === "true",
                                value: d.device_id + "@" + d.location_id,
                                label: zone.location_name
                            });
                        }
                    }
                    console.log('cDevices', cDevices);
                    setCommboxDevices(cDevices);
                } else {
                    setCommboxDevices([]);
                }
            },
            (res) => {
                setCommboxDevices([]);
            });
    }

    let isLSSPauseExtendAllowed = () => {
        if (!site_selected)
            return;

        let siteObj = JSON.parse(JSON.stringify(site_selected));
        let site_security_lss = siteObj.site_security_lss;
        let allow_pause_extend = false;
        if (!site_security_lss.pause_lss_till) {
            allow_pause_extend = true;
        } else if (site_security_lss.pause_lss_till > (Date.now())) {
            if (site_security_lss.allow_pause_extend) {
                allow_pause_extend = true;
            } else {
                allow_pause_extend = false;
            }
        } else if (site_security_lss.pause_lss_till < (Date.now())) {
            allow_pause_extend = true;
        }
        return allow_pause_extend;
    }

    let pauseNotifications = (pause_millis) => {
        let siteObj = JSON.parse(JSON.stringify(site_selected));
        let site_security_lss = siteObj.site_security_lss;
        if (site_security_lss && site_security_lss.active) {

            let allow_pause_extend = false;
            let pause_lss_till = pause_millis || (Date.now() + 15 * 60 * 1000);

            if (!site_security_lss.pause_lss_till || pause_millis) {
                allow_pause_extend = true;
            } else if (site_security_lss.pause_lss_till > (Date.now())) {
                if (site_security_lss.allow_pause_extend) {
                    allow_pause_extend = false;
                    pause_lss_till = (site_security_lss.pause_lss_till + 5 * 60 * 1000);
                } else {
                    Toastr.error('Pause timer can\'t be altered till <br />' + new Date(site_security_lss.pause_lss_till));
                    return;
                }
            } else if (site_security_lss.pause_lss_till < (Date.now())) {
                allow_pause_extend = true;
            }

            site_security_lss.pause_lss_till = pause_lss_till; //Date.now();
            site_security_lss.allow_pause_extend = allow_pause_extend;
            siteObj.site_security_lss = site_security_lss;
        } else {
            return;
        }

        let data = {
            user_login: user.user_login,
            user_token: user.user_token,
            user_type: 'user',
            form_input: {
                customer_id: site_selected.customer_id,
                site_id: site_selected.site_id,
                site_security_lss: site_security_lss
            }
        };

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/site/modify',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code !== 200) {
                    Toastr.error('An error occured ...please try again.', 'Error');
                    return;
                } else {
                    var sessionMgr = new SessionManager();
                    let userU = sessionMgr.readCookie("user");
                    userU.site_selected = siteObj;
                    setSiteSelected(siteObj);
                    sessionMgr.storeCookie('user', userU);

                    if (!pause_millis)
                        Toastr.success('Notifications paused till <br />' + new Date(site_security_lss.pause_lss_till), 'Success');
                    else
                        Toastr.success('Notifications are active', 'Success');
                }
            },
            (res) => {
                Toastr.error('An error occured ...please try again.', 'Error');
            });
    }

    const performTimerOperation = (t) => {
        switch (t.key) {
            case 'ExtendTimer':
                pauseNotifications();
                break;

            case 'CancelTimer':
                pauseNotifications(Date.now());
                break;

            default:
                break;
        }
    }

    const zoneCount = zones ? zones.length : 0;
    const zoneCardClassName = 'col-md-' + ((zoneCount > 0 && zoneCount < 4) ? (12 / zoneCount) : 4);
    const savePrefsContent = save_prefs ? <Loading>Saving Preferences ...</Loading> : <><i className='fa fa-th mr-2'></i> Save Preferences</>;
    const lss_paused_till = (site_selected && site_selected.site_security_lss && site_selected.site_security_lss.pause_lss_till) || 0;
    const lss_pause_allowed = (site_selected && site_selected.site_security_lss);
    const timerOpts = lss_pause_allowed ? {
        items: [
            {
                label: 'Extend Timer',
                key: 'ExtendTimer',
                disabled: !isLSSPauseExtendAllowed()
            },
            {
                label: 'Cancel Timer',
                key: 'CancelTimer',
            }
        ], onClick: (t) => performTimerOperation(t)
    } : {};

    const fetchCustomer = async () => {
        let _c = await CommonUtils.getCustomer(user.customer_id || user.site_selected.customer_id, user);
        setCustomer(_c);
    }

    let site_loc_recs = [];
    if (customer && customer.leadership_sites)
        for (let s of Object.keys(customer.leadership_sites))
            for (let l of customer.leadership_sites[s]) {
                site_loc_recs.push({ location_id: l, site_id: s });
            }

    const talk_down_devices = commboxDevices && commboxDevices.length > 0 && commboxDevices.filter(d => d.talkDownEnabled);
    const strobe_devices = commboxDevices && commboxDevices.length > 0 && commboxDevices.filter(d => d.strobeEnabled);

    const foundStrobeDevices = strobe_devices && strobe_devices.length > 0;
    const foundTalkDownDevices = talk_down_devices && talk_down_devices.length > 0;

    return (
        <React.Fragment>
            <div className="page-container">
                <div className="row px-0">
                    <div className={"col-md-4 pl-4 mb-2"} style={{ lineHeight: '24px' }}>
                        <Select
                            style={{ width: '200px' }}
                            className='font-size-13 w-175 site_picker'
                            dropdownMatchSelectWidth={false}
                            filterOption={(input, option) =>
                                (option.label).toLowerCase().includes(input.toLowerCase())
                            }
                            showSearch
                            value={site_selected && site_selected.site_id}
                            onChange={(...args) => {
                                onSiteLocationChange(args[1].site);
                            }}
                            options={site_locations && site_locations.map((a) => { return { value: a.site_id, label: a.site_name + ', ' + a.site_city, site: a }; })}
                            placeholder="Choose Site" />

                    </div>

                    <div className={"col-md-4 pl-4 pr-4 mb-2"}>
                        {site_selected && <div className="bg-white border-rounded font-size-12 py-custom text-md-center"><SiteWeather site={site_selected}></SiteWeather></div>}
                    </div>
                    <div className={"col-md-4 pl-4 pr-4 mb-2 align-right"}>
                        {CommonUtils.hasPermission('SITESUPT-UI-PAUSE-NOTIFICATIONS') && lss_pause_allowed && <>
                            {lss_paused_till > Date.now() && <>
                                <Space wrap>
                                    <Dropdown.Button menu={timerOpts} placement="bottom" trigger="click">
                                        <i className='fa fa-lg text-primary fa-clock' /> &nbsp; &nbsp; <CountdownTimer targetDate={lss_paused_till} onStop={() => { setLoading(true); setLoading(false) }} />
                                    </Dropdown.Button>
                                </Space>
                            </>}
                            {(lss_paused_till < Date.now()) && <button onClick={() => pauseNotifications()} className='btn btn-xs btn-white ml-2'>Pause Notifications</button>}
                        </>}
                        {foundTalkDownDevices && CommonUtils.hasPermission('SITESUPT-UI-TALK-DOWN') && <Modal ref={React.createRef()} title="Talk Down" id="deleteSensorsModal" label={<button className='btn btn-xs btn-white ml-2'><i className='fa fa-bullhorn text-danger'></i> Talk Down</button>} size="modal-md">
                            <TalkDownModal devices={talk_down_devices}></TalkDownModal>
                        </Modal>}
                        {foundStrobeDevices && CommonUtils.hasPermission('SITESUPT-UI-TALK-DOWN') && <Modal ref={React.createRef()} title="Strobe" id="StrobeModal" label={<button className='btn btn-xs btn-white ml-2'><i className='fa fa-bullhorn text-danger'></i> Strobe</button>} size="modal-md">
                            <StrobeModal devices={strobe_devices}></StrobeModal>
                        </Modal>}
                        {zoneOrderChanged() && <button className="btn btn-sm btn-primary ml-2" onClick={saveZoneOrderPreferences} disabled={save_prefs}>{savePrefsContent}</button>}
                        {!foundTalkDownDevices && zoneOrderChanged() && <button className="btn btn-sm btn-primary ml-2" onClick={saveZoneOrderPreferences} disabled={save_prefs}>{savePrefsContent}</button>}
                    </div>
                </div>

                {site_locations && site_locations.length > 0 &&
                    <React.Fragment>
                        <div className="row sortable">
                            {
                                zones && zones.map((zone, i) => (
                                    <div key={i} className={zoneCardClassName} zone={zone.location_id}>
                                        <ZoneCard is_favourite={site_loc_recs.find(x => x.location_id === zone.location_id)} events_info={zone_events[zone.location_id]} zone={zone} fetchLocations={fetchSiteLocationZones} site={site_selected} last_refresh={last_refresh}></ZoneCard>
                                    </div>
                                ))
                            }
                            {
                                loading && <div className="col-md-12 text-center mt-5"><Loading>Fetching Zones Information ... </Loading></div>
                            }
                        </div>

                    </React.Fragment>
                }

                {
                    !loading && !zones.length > 0 && <div className="col-md-12 text-center mt-5"> No accessible zones found ... </div>
                }

            </div>

        </React.Fragment>
    );
}

export default DashboardSites;